export default __webpack_public_path__ + "static/media/payment.6e0dd146.webp";